import { useTranslation } from 'next-i18next/pages';
import Link from 'next/link';
import { ReactNode } from 'react';

import { DataTestId } from '@pflegia/types/api/general/data-test-id';

import NotificationMarker from '../notification-marker';

interface QuickLinkProps extends DataTestId {
  children: ReactNode;
  hasNewActivity?: boolean;
  href: string;
}

/**
 * Primary UI Navigation component
 */
export const QuickLinkComponent: React.FC<QuickLinkProps> = ({ children, hasNewActivity = false, href, 'data-testid': dataTestId }) => {
  const { t } = useTranslation('common');
  return (
    <Link
      href={href}
      data-testid={dataTestId}
      className='rounded-4xl text-primary hover:bg-primary group relative inline-flex items-center justify-center bg-white px-1 py-6 text-center text-xs hover:text-white hover:shadow-xl sm:text-base md:text-lg lg:p-9 lg:text-xl'>
      {hasNewActivity && <NotificationMarker label={t('newActivity')} shouldAnimate size='large' />}
      {children}
    </Link>
  );
};

export default QuickLinkComponent;
